export default __webpack_public_path__ + "static/media/Binding of the Enslaving Opiate.ceeca594.jpg";